document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("custom-popup");
  const closeBtn = document.querySelector(".popup-close");

  // Check cookie
  const hasCookie = document.cookie.split("; ").includes("popupClosed=true");
  if (hasCookie) return;

  // Show popup after 5 seconds
  setTimeout(() => {
    popup.style.display = "flex";
  }, 5000);

  // Close popup and set cookie
  const closePopup = () => {
    popup.style.display = "none";
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 3);
    document.cookie = `popupClosed=true; expires=${expiryDate.toUTCString()}; path=/`;
  };

  closeBtn.addEventListener("click", closePopup);
  popup.addEventListener("click", (e) => {
    if (e.target === popup) closePopup();
  });
});